import { createArticleFilter } from '.';
import { queryAll, query } from '~/lib/utils/dom';
queryAll('.js-article-filter')
    .map((main) => ({
    main,
    topic: query('.js-article-filter-topic', main),
}))
    .map(createArticleFilter);
